import React from 'react'
import { Image } from 'semantic-ui-react'
import logo from 'assets/images/RDP.png'
import './HomePage.scss'

export default function HomePage() {
    return (
        <div id="home" className='d-flex flex-grow-1 flex-column'>
            <h2 className='mt-0'>INTRANET - RDPNET</h2>
            <Image className='logo' size='small' rounded src={logo} />
        </div>
    )
}
